(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ie-pojisteni-products"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const blocks = document.querySelectorAll('.block-text > div[class^="pojisteni-product"]');
        const products = document.querySelectorAll('.product');
    
        if(screen.width <= 768){
            blocks.forEach(b => {
                b.addEventListener("click",(e)=>{e.preventDefault()})
            });
        }
    
        
        function setActiveBlock(block) {
  
            blocks.forEach(b => b.classList.remove('active'));
            block.classList.add('active');
        }
    
        function updateSvgVisibility() {
            const product1Visible = document.querySelector('.product-2').style.position !== 'absolute';
        }
    
        blocks.forEach(block => {
            block.addEventListener('click', function() {
                products.forEach(img => {
                    img.style.opacity = '0';
                    img.style.position = 'absolute';
                });
                const productClass = this.getAttribute('data-product');
                document.querySelector(`.${productClass}`).style.opacity = '1';
                document.querySelector(`.${productClass}`).style.position = 'relative';
                setActiveBlock(this);
                updateSvgVisibility();
            });
        });
    
        // blocks.forEach(block => {
        //     block.addEventListener('mouseleave', function() {
        //         images.forEach(img => {
        //             img.style.opacity = '0';
        //             img.style.position = 'absolute';
        //         });
        //         document.querySelector('.image-1').style.position = 'relative';
        //         document.querySelector('.image-1').style.opacity = '1';
        //         setActiveBlock(blocks[0]);
        //         updateSvgVisibility();
        //     });
        // });
    
        // Set initial state
        setActiveBlock(blocks[0]);
        updateSvgVisibility();
    });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-safe_purchase-usp"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const blocks = document.querySelectorAll('.block-text > a[class^="car"]');
    const images = document.querySelectorAll('.image');
    const svgElement = document.getElementById('usp-svg');

    if(screen.width <= 768){
        blocks.forEach(b => {
            b.addEventListener("click",(e)=>{e.preventDefault()})
        });
    }

    
    function setActiveBlock(block) {

        blocks.forEach(b => b.classList.remove('active'));
        block.classList.add('active');
    }

    function updateSvgVisibility() {
        const image1Visible = document.querySelector('.image-2').style.position !== 'absolute';
        svgElement.style.opacity = image1Visible ? '1' : '0';
    }

    blocks.forEach(block => {
        block.addEventListener('mouseenter', function() {
            images.forEach(img => {
                img.style.opacity = '0';
                img.style.position = 'absolute';
            });
            const imageClass = this.getAttribute('data-image');
            document.querySelector(`.${imageClass}`).style.opacity = '1';
            document.querySelector(`.${imageClass}`).style.position = 'relative';
            setActiveBlock(this);
            updateSvgVisibility();
        });
    });

    blocks.forEach(block => {
        block.addEventListener('mouseleave', function() {
            images.forEach(img => {
                img.style.opacity = '0';
                img.style.position = 'absolute';
            });
            document.querySelector('.image-1').style.position = 'relative';
            document.querySelector('.image-1').style.opacity = '1';
            setActiveBlock(blocks[0]);
            updateSvgVisibility();
        });
    });

    // Set initial state
    setActiveBlock(blocks[0]);
    updateSvgVisibility();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmi-hero-review"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const blocks = document.querySelectorAll('.block-text > a[class^="car"]');
    const images = document.querySelectorAll('.image');
    const svgElement = document.getElementById('usp-svg');
    
    function setActiveBlock(block) {
        blocks.forEach(b => b.classList.remove('active'));
        block.classList.add('active');
    }

    function updateSvgVisibility() {
        const image2Visible = document.querySelector('.image-2').style.display !== 'none';
        svgElement.style.opacity = image2Visible ? '1' : '0';
    }

    blocks.forEach(block => {
        block.addEventListener('mouseenter', function() {
            images.forEach(img => img.style.display = 'none');
            const imageClass = this.getAttribute('data-image');
            document.querySelector(`.${imageClass}`).style.display = 'block';
            setActiveBlock(this);
            updateSvgVisibility();
        });
    });

    blocks.forEach(block => {
        block.addEventListener('mouseleave', function() {
            images.forEach(img => img.style.display = 'none');
            document.querySelector('.image-1').style.display = 'block';
            setActiveBlock(blocks[0]);
            updateSvgVisibility();
        });
    });

    // Set initial state
    setActiveBlock(blocks[0]);
    updateSvgVisibility();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmi-usp-hero-subtitle-autobezobav"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const blocks = document.querySelectorAll('.block-text > a[class^="car"]');
    const images = document.querySelectorAll('.image');
    const svgElement = document.getElementById('usp-svg');
    
    function setActiveBlock(block) {
        blocks.forEach(b => b.classList.remove('active'));
        block.classList.add('active');
    }

    function updateSvgVisibility() {
        const image2Visible = document.querySelector('.image-2').style.display !== 'none';
        svgElement.style.opacity = image2Visible ? '1' : '0';
    }

    blocks.forEach(block => {
        block.addEventListener('mouseenter', function() {
            images.forEach(img => img.style.display = 'none');
            const imageClass = this.getAttribute('data-image');
            document.querySelector(`.${imageClass}`).style.display = 'block';
            setActiveBlock(this);
            updateSvgVisibility();
        });
    });

    blocks.forEach(block => {
        block.addEventListener('mouseleave', function() {
            images.forEach(img => img.style.display = 'none');
            document.querySelector('.image-1').style.display = 'block';
            setActiveBlock(blocks[0]);
            updateSvgVisibility();
        });
    });

    // Set initial state
    setActiveBlock(blocks[0]);
    updateSvgVisibility();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmi-usps-hero-subtitle-kampan20000"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const blocks = document.querySelectorAll('.block-text > a[class^="car"]');
    const images = document.querySelectorAll('.image');
    const svgElement = document.getElementById('usp-svg');
    
    function setActiveBlock(block) {
        blocks.forEach(b => b.classList.remove('active'));
        block.classList.add('active');
    }

    function updateSvgVisibility() {
        const image2Visible = document.querySelector('.image-2').style.display !== 'none';
        svgElement.style.opacity = image2Visible ? '1' : '0';
    }

    blocks.forEach(block => {
        block.addEventListener('mouseenter', function() {
            images.forEach(img => img.style.display = 'none');
            const imageClass = this.getAttribute('data-image');
            document.querySelector(`.${imageClass}`).style.display = 'block';
            setActiveBlock(this);
            updateSvgVisibility();
        });
    });

    blocks.forEach(block => {
        block.addEventListener('mouseleave', function() {
            images.forEach(img => img.style.display = 'none');
            document.querySelector('.image-1').style.display = 'block';
            setActiveBlock(blocks[0]);
            updateSvgVisibility();
        });
    });

    // Set initial state
    setActiveBlock(blocks[0]);
    updateSvgVisibility();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmi-usps-hero-subtitle"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const blocks = document.querySelectorAll('.block-text > a[class^="car"]');
    const images = document.querySelectorAll('.image');
    const svgElement = document.getElementById('usp-svg');
    
    function setActiveBlock(block) {
        blocks.forEach(b => b.classList.remove('active'));
        block.classList.add('active');
    }

    function updateSvgVisibility() {
        const image2Visible = document.querySelector('.image-2').style.display !== 'none';
        svgElement.style.opacity = image2Visible ? '1' : '0';
    }

    blocks.forEach(block => {
        block.addEventListener('mouseenter', function() {
            images.forEach(img => img.style.display = 'none');
            const imageClass = this.getAttribute('data-image');
            document.querySelector(`.${imageClass}`).style.display = 'block';
            setActiveBlock(this);
            updateSvgVisibility();
        });
    });

    blocks.forEach(block => {
        block.addEventListener('mouseleave', function() {
            images.forEach(img => img.style.display = 'none');
            document.querySelector('.image-1').style.display = 'block';
            setActiveBlock(blocks[0]);
            updateSvgVisibility();
        });
    });

    // Set initial state
    setActiveBlock(blocks[0]);
    updateSvgVisibility();
});

  } catch(e) { console.error(e); }
})();
})();
